import { TREND_NOTE, isMeaningfulChange } from '../../constants';

// Each row is drawn against the org's rating scale (1..6 or 1..4, see
// utils/scaleConfig), with the favorable band shaded from its threshold to the
// top. Same scale the single-round sections use, so a score means the same
// thing here as it does there.

// Position of a rating along the scale as a 0..100 percentage.
export const scalePct = (value, scale) =>
    ((value - scale.min) / (scale.max - scale.min)) * 100;

export const HEADER_TEXT = (scale) => ({
    title: 'What moved most',
    description: `Each category's All But Self mean at the earlier and the latest 360, sorted by size of change. The favorable band (${scale.favorableThreshold}+) is shaded.`,
    note: TREND_NOTE,
});

export const GROUP_TEXT = {
    improved: 'Improved',
    declined: 'Declined or flat',
};

// A category's change, and how strongly to draw it. The API may hand back its
// own delta computed from unrounded means — which is why a row's delta is
// trusted when present rather than always re-derived from the two shown values.
export const deltaFor = (row) => (row.delta != null ? row.delta : row.latest - row.earlier);

// Improved / declined splits on the sign; muted is about size, so a small
// improvement and a small decline are both drawn faintly.
export const toneFor = (delta) => {
    if (!isMeaningfulChange(delta)) return 'muted';
    return delta > 0 ? 'up' : 'down';
};
